/* ==========================================================================
   ModalRxjs > Client > Config
   ========================================================================== */

/* Import modules */

/* Config */
const config = {
    component: 'ModalRxjs',
    init: true,
    start: true,
    css: {
        close: 'modal-rxjs__close',
        visible: 'is-visible',
        modalVisible: 'modal-is-visible'
    },
    type: {
        close: 'modal-rxjs-close'
    },
    icon: {
        cancel: 'cancel'
    }
};

module.exports = () => config;
